import React, { useState } from 'react';
import { X, Save, TestTube } from 'lucide-react';
import { InkQuoteApi } from '../../services/inkquoteApi';
import './InkQuoteApiConfig.css';

const InkQuoteApiConfig = ({ isOpen, onClose, onSave }) => {
  const config = InkQuoteApi.getConfig();
  const [baseUrl, setBaseUrl] = useState(config.baseUrl || 'http://localhost:150');
  const [apiKey, setApiKey] = useState(config.apiKey || '');
  const [testStatus, setTestStatus] = useState(null);
  const [isTesting, setIsTesting] = useState(false);

  if (!isOpen) return null;

  const handleTest = async () => {
    setIsTesting(true);
    setTestStatus(null);
    try {
      const response = await fetch(`${baseUrl}/inkquote/history/recent?limit=1`, {
        headers: { 'Authorization': `Bearer ${apiKey}` }
      });
      if (response.ok) {
        setTestStatus({ success: true, message: 'Connection successful!' });
      } else {
        setTestStatus({ success: false, message: `HTTP ${response.status}: ${response.statusText}` });
      }
    } catch (error) {
      setTestStatus({ success: false, message: error.message });
    } finally {
      setIsTesting(false);
    }
  };

  const handleSave = () => {
    InkQuoteApi.saveConfig(baseUrl, apiKey);
    onSave();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  return (
    <div className="api-config-overlay" onClick={onClose}>
      <div className="api-config-modal" onClick={(e) => e.stopPropagation()}>
        <div className="api-config-header">
          <h2 className="api-config-title">API Configuration</h2>
          <button
            onClick={onClose}
            className="api-config-close-button"
            aria-label="Close configuration"
          >
            <X size={20} />
          </button>
        </div>

        <div className="api-config-content">
          <div className="api-config-field">
            <label className="api-config-label">
              API Base URL
            </label>
            <input
              type="text"
              value={baseUrl}
              onChange={(e) => setBaseUrl(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="http://localhost:150"
              className="api-config-input"
            />
          </div>

          <div className="api-config-field">
            <label className="api-config-label">
              API Key
            </label>
            <input
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Your InkQuote API key"
              className="api-config-input"
            />
          </div>

          {baseUrl.startsWith('http://') && (
            <div className="api-config-warning">
              Warning: Using HTTP with HTTPS site may be blocked by browser. Consider using HTTPS for your API or accessing this app via HTTP.
            </div>
          )}

          {testStatus && (
            <div className={`api-config-status ${testStatus.success ? 'success' : 'error'}`}>
              {testStatus.message}
            </div>
          )}

          <div className="api-config-actions">
            <button
              onClick={handleTest}
              disabled={isTesting}
              className="api-config-button test"
            >
              <TestTube size={16} />
              <span>{isTesting ? 'Testing...' : 'Test Connection'}</span>
            </button>
            <button
              onClick={handleSave}
              className="api-config-button save"
            >
              <Save size={16} />
              <span>Save & Load</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InkQuoteApiConfig;
